/* global PROJECT_ENV */
const processEnv = typeof PROJECT_ENV !== 'undefined' ? PROJECT_ENV.processEnv : {};
const BACKOFFICE_ENV = processEnv.BACKOFFICE_ENV || 'development';
const apiEnv = processEnv.BACKOFFICE_API_ENV || 'dev';
const storeKindENV = processEnv.BACKOFFICE_STORE_KIND || 'Jumbo';
const baseUrl = processEnv.BACKOFFICE_URL || 'https://cl-backoffice-dev.smdigital.cl';
const graphQLUrl = processEnv.GRAPHQL_URL || 'http://localhost:8083/';
const isProd = apiEnv === 'prod';

const publicRuntimeConfig = {
    basePath: '',
    GRAPHQL_URL: graphQLUrl,
    ALI_FONT_CDN: 'https://at.alicdn.com/t/font_1259175_mg17yqg9xj.js',
    settings: {
        isProd,
        baseUrl,
        siteName: BACKOFFICE_ENV === 'development' ? '(DEV) BackJumbo.cl' : 'BackJumbo.cl',
        backOfficeENV: BACKOFFICE_ENV,
        cognitoClientIDENV: processEnv.BACKOFFICE_COGNITO_CLIENT_ID || '2rqbi9eqdqcpp1inaod5rs78mb',
        cognitoPoolIDENV: processEnv.BACKOFFICE_COGNITO_POOL_ID || 'us-east-1_Bt8uKdgKd',
        identityPoolId: processEnv.AWS_COGNITO_IDENTITY_POOL_ID || 'us-east-1:39d3e728-551c-42fc-8626-910795a680af',
        domain: processEnv.AWS_COGNITO_CLIENT_DOMAIN_NAME || 'cl-user-management-dev.auth.us-east-1.amazoncognito.com',
        name: processEnv.AWS_COGNITO_IDP_NAME || 'ADFS-TEST',
        oathClaims: processEnv.AWS_COGNITO_IDP_OAUTH_CLAIMS || ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
        grantFlow: processEnv.AWS_COGNITO_IDP_GRANT_FLOW || 'code',
        signInUrl: processEnv.AWS_COGNITO_IDP_SIGNIN_URL || 'https://cl-backoffice-dev.smdigital.cl/redirect',
        signOutUrl: processEnv.AWS_COGNITO_IDP_SIGNOUT_URL || 'https://cl-backoffice-dev.smdigital.cl/redirect',
        msSplitApiKey: processEnv.API_KEY_MS_SPLIT || 'VmpGb2QxTXlTa1pPVm1oVVlsaFNVRlpyVlRGalJsSg==',
        msProductsSplitUrl: processEnv.MS_PRODUCTS_SPLIT || 'https://split-microservices-products.ecomm-stg.cencosud.com',
        pollIntervalTimeOut: 180000,
        storeKind: storeKindENV,
        usersWhiteList: [
            'ronald.suezascanio@cencosud.cl',
            'bockdandavid.porras@cencosud.cl'
        ],
        recaptchaToken: processEnv.BACKOFFICE_RECAPTCHA_TOKEN || '6Le3sUosAAAAAG9PjNqrG6XY5iBI4sFjnQoTMa6e',
        commandOrdersUrl: isProd ? 'https://command-microservices-orders.ecomm.cencosud.com' : 'https://command-microservices-orders.ecomm-stg.cencosud.com',
        commandOrdersApiKey: processEnv.BACKOFFICE_COMMAND_ORDERS_API_KEY || 'b11d5674342eComM46f4c89e2f1daf5a'
    },
    metadata: {
        VERSION: processEnv.npm_package_version
    },
    invoiceUrl: isProd ? [
        'https://cencosud-jumbo-backoffice-invoice.ecomm.cencosud.com',
        'http://cencosud.paperless.cl'
    ] : [
        'https://cencosud-jumbo-backoffice-invoice.ecomm-stg.cencosud.com',
        'http://cencosudqa.paperless.cl'
    ],
    deliveryUrl: isProd ? 'https://backoffice.ecomm.cencosud.com' : 'https://backoffice.ecomm-stg.cencosud.com' // Yes, this will be changed for Cenco account...
};

export {
    publicRuntimeConfig
};
